import PropTypes from 'prop-types'
import styled from 'styled-components'
import IconLink from 'components/Shared/IconLink/Index'
import Tooltip from 'components/Shared/Tooltip/Index'
import colors from 'components/utils/colors'

const StyledSection = styled.section`
  display: flex;
  padding: 12px 16px;
  height: 15px;
`

const StyledToolTipIcon = styled(IconLink)`
  margin-left: 5px;
`

const StyledTitle = styled.h4`
  display: flex;
  align-items: center;
  flex: 1;
  padding-bottom: 0px;
  display: flex;
  font-size: 14px;
  color: ${colors.secondary20};
  font-weight: 500;
  text-transform: uppercase;
  font-family: Exo;
  position: relative;
`

const IconWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0
`

const SidebarSectionGroupTitle = ({ title, tooltipText, icon }) => {
  return (
    <StyledSection>
      {title && (
        <StyledTitle
          data-tooltip-content={tooltipText || undefined}
          data-tooltip-id='sider-bar-tooltip'
        >
          {title}
          {tooltipText && (
            <StyledToolTipIcon
              iconName='icon-help-16'
            />
          )}
          {icon && <IconWrapper>{icon}</IconWrapper>}
        </StyledTitle>
      )}
      <Tooltip id='sider-bar-tooltip' place='left' delayHide={500} />
    </StyledSection>
  )
}

SidebarSectionGroupTitle.propTypes = {
  title: PropTypes.string,
  tooltipText: PropTypes.string,
  icon: PropTypes.node,
}

export default SidebarSectionGroupTitle
